"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const DocumentIcon = createSVGIcon(
  <path
    d="M7.5 1.25H.75v13.5h10.5V5M7.5 1.25l1.875 1.875L11.25 5M7.5 1.25V5h3.75"
    stroke="currentColor"
  />,
  "Document",
  { viewBox: "0 0 23 17", fill: "none", className: legacyIconCls() }
);
